module.exports = __webpack_public_path__ + "static/media/info.d2d6542a.svg";